var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "36px",
    viewBox: "0 0 25 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "22C4A650-06F6-40F3-ABB9-76CAAA158446") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VertexAiPage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VertexAILanding",
    transform: "translate(-906.000000, -944.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(87.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 509.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(672.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.375,288.75 C163.103672,288.75 166.125,285.728672 166.125,282 L160.5,282 C159.88125,282 159.375,281.49375 159.375,280.875 C159.375,280.25625 159.88125,279.75 160.5,279.75 L166.125,279.75 L166.125,277.5 L160.5,277.5 C159.88125,277.5 159.375,276.99375 159.375,276.375 C159.375,275.75625 159.88125,275.25 160.5,275.25 L166.125,275.25 L166.125,272.936719 L160.5,272.936719 C159.878719,272.936719 159.375,272.433 159.375,271.811719 C159.375,271.190437 159.878719,270.686719 160.5,270.686719 L166.125,270.75 C166.125,267.021328 163.103672,264 159.375,264 C155.646328,264 152.625,267.021328 152.625,270.75 L152.625,282 C152.625,285.726562 155.585156,288.75 159.375,288.75 Z M170.0625,277.5 C169.127344,277.5 168.375,278.252344 168.375,279.124219 L168.375,282 C168.375,287.156016 164.017734,291.309375 158.791406,290.978906 C154.145156,290.685773 150.375,286.296797 150.375,281.641406 L150.375,279.124219 C150.375,278.252344 149.619141,277.5 148.6875,277.5 C147.755859,277.5 147,278.252344 147,279.124219 L147,281.384766 C147,287.688984 151.497891,293.309766 157.6875,294.160547 L157.6875,296.625 L154.875,296.625 C153.596016,296.625 152.565937,297.692344 152.627813,298.985391 C152.655234,299.564062 153.173438,300 153.75,300 L165,300 C165.578109,300 166.094766,299.562937 166.122187,298.985391 C166.18125,297.69375 165.154687,296.625 163.875,296.625 L161.0625,296.625 L161.0625,294.250547 C167.088281,293.425781 171.75,288.250781 171.75,282 L171.75,279.124219 C171.75,278.252344 170.997656,277.5 170.0625,277.5 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.90a7440a7c3ba9beaf836abda0f9e65f.svg";
export { ForwardRef as ReactComponent };